import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Comparativa } from './components/Comparativa';
import { Sistema } from './components/Sistema';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { ValueStack } from './components/ValueStack';
import { Ofertas } from './components/Ofertas';
import { ParaQuien } from './components/ParaQuien';
import { Testimonios } from './components/Testimonios';
import { ComoFunciona } from './components/ComoFunciona';
import { Garantia } from './components/Garantia';
import { CierreFinal } from './components/CierreFinal';
import { Faq } from './components/Faq';
import { SiteFooter } from './components/SiteFooter';
import { VentasFlotantes } from './components/VentasFlotantes';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-canvas font-sans" data-id="element-0" data-mp="23v2td3l0915e">
      <TopBar data-id="element-1" data-mp="3ikh5c1uvgeva" />
      <Hero data-id="element-2" data-mp="3iiwfgpji5k3r" />
      <main data-id="element-3" data-mp="3ijfwm41bw4gq">
        <Comparativa data-id="element-4" data-mp="3ijpcuzwkmx98" />
        <Sistema data-id="element-5" data-mp="3ii4ppvcl6gle" />
        <Tomos data-id="element-6" data-mp="3mlatmwc87vop" />
        <Bonos data-id="element-7" data-mp="3mkrcviybbdc9" />
        <ValueStack data-id="element-8" data-mp="3mk85gw6ag7ch" />
        <Ofertas data-id="element-9" data-mp="3mjpyb4i388ps" />
        <ParaQuien data-id="element-10" data-mp="3mj6lg27aoaim" />
        <Testimonios data-id="element-11" data-mp="3rbr9en3irte8" />
        <ComoFunciona data-id="element-12" data-mp="3rdas0kcnegj6" />
        <Garantia data-id="element-13" data-mp="3rcsuzli5vya7" />
        <CierreFinal data-id="element-14" data-mp="3reltuemj9e7n" />
        <Faq data-id="element-15" data-mp="5or2zhbcs60" />
      </main>
      <SiteFooter data-id="element-16" data-mp="4wv3njt0sf7" />
      <VentasFlotantes data-id="element-17" data-mp="5gfdawxfswe" />
    </div>;
}